import { type ReactNode } from "react";

/**
 * The one page header for every school-portal tab (Overzicht, Gegevens, Programma,
 * Berichten). Identical typography + spacing everywhere, so the title stays pinned in
 * the same spot and at the same size when switching tabs (no font "jump"). The subtitle
 * is always a single short line; longer reassurance lives elsewhere (e.g. the SaveToast).
 */
export function PortalHeader({
  title,
  subtitle,
  action,
}: {
  title: string;
  subtitle?: string;
  action?: ReactNode;
}) {
  return (
    <div className="mb-6 flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-xl font-bold tracking-tight text-foreground">{title}</h1>
        {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
